import * as React from 'react';
import { useEffect } from 'react';
import { Filter, getAppStore } from '../../../../@data';
import { DefaultRoute } from '../../../../Routes';
import { ZeroResults } from '../../../../components/ZeroResults/ZeroResults';
import { useWindowSize } from '../../../../hooks';
import { getStore as getWindowSizeStore } from '../../../../hooks/useWindowSize/store/store';
import { GridPageLayout } from '../../../../layout/GridPageLayout/GridPageLayout';
import { GridV2, IGridV2Column } from '../../../../layout/GridPageV2';
import { IRouterWithIntl, injectIntlWithObserver } from '../../../../utils/ReactUtils';
import { RouteName } from '../../@data';
import { getFilterStore } from '../@data';
import { onFiltersFetched } from '../@data/actions';
import { onManagePageInitialized } from '../@data/actions/onManagePageInitialized';
import messages from './ManagePage.messages';
import { getCommandBarItems } from './utils/getCommandBarItems';
import { getGridColumns } from './utils/getGridColumns';

export const ManagePage = injectIntlWithObserver(function FilterManagePage(props: IRouterWithIntl) {
  const { publisher, account } = getAppStore();
  const { gridFilters, isLoading, isFetchingData } = getFilterStore();
  const { formatMessage } = props.intl;
  const { windowStoreSerializer } = useWindowSize();
  const { isWindowRegularSize } = windowStoreSerializer(getWindowSizeStore());
  const gridDefaultColumns: IGridV2Column[] = getGridColumns(formatMessage, isWindowRegularSize, props.history);

  const NoResultComponent = (
    <ZeroResults
      showDefaultImage
      title={!!publisher ? formatMessage(messages.zeroResultTitle) : undefined}
      description={formatMessage(!!publisher ? messages.zeroResultDescription : messages.noPublisherSelected)}
      buttonText={formatMessage(messages.create)}
      onButtonClick={
        !!publisher ? () => props.history.push(`${DefaultRoute}/${publisher?.id}-${account?.id}/${RouteName.adfilter}/create`) : undefined
      }
    />
  );

  useEffect(() => {
    onManagePageInitialized();
    // eslint-disable-next-line
  }, [publisher, account]);

  return (
    <GridPageLayout>
      <GridV2
        history={props.history}
        location={props.location}
        match={props.match}
        entity={Filter}
        pageTitle={{ title: formatMessage(messages.adfilters), helpId: 'pop_PCv4_Filters' }}
        commandBarProps={getCommandBarItems(formatMessage)}
        dataGridProps={{
          gridV2Columns: gridDefaultColumns,
          data: publisher && account ? gridFilters || [] : [],
          setData: onFiltersFetched,
          shimmerLines: 10,
          renderZeroItemsComponent: NoResultComponent,
        }}
        isGridReady={!isLoading}
        isDataLoading={isFetchingData}
        paginationProps={{
          shouldGridHandlePagination: true,
        }}
      />
    </GridPageLayout>
  );
});
